import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';

import * as commonVar from 'libs/commonVar';

import { Container, Grid, Header, Icon, Image, Input, Segment } from 'semantic-ui-react';
import { Footer, Button } from 'components';

import styles from './Intro.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class Intro extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    return (
      <div className={cx('intro-wrapper')}>
        <div className={cx('intro-wrapper-inner')}>
          {/* 영역 1 */}
          <Segment inverted textAlign="center" className={cx('area-1')} vertical>
            <Container text>
              {/* <Header as="h1" inverted className={cx('area-1-mainText')} content="Think Before You CLICK!" /> */}
              <img src="/img/main_text.png" className={cx('area-1-mainText')} />
              <Header
                as="h5"
                inverted
                className={cx('area-1-subText-1')}
                content={defineMessages(
                  formatMessage({
                    id: 'Intro_26',
                    defaultMessage: '"보안의 시작과 끝은 사람"'
                  })
                )}
              />
              <Header
                as="h5"
                inverted
                className={cx('area-1-subText-2')}
                content={defineMessages(
                  formatMessage({
                    id: 'Intro_1',
                    defaultMessage: '악성 메일 모의 테스트로 보안 인식 수준을 점검하세요.'
                  })
                )}
              />
              <Button
                primary
                size="large"
                className={cx('area-1-bt-start')}
                onClick={() => {
                  window.location.href = '/login';
                }}>
                {defineMessages(formatMessage({ id: 'Intro_2', defaultMessage: '시작하기' }))}
              </Button>
            </Container>
          </Segment>
          {/* 영역 2 */}
          <Segment className={cx('area-2')} vertical>
            <Grid container stackable verticalAlign="middle">
              <Grid.Row>
                <Grid.Column textAlign="center" width={7}>
                  <img className={cx('area-2-img')} src="/img/intro/intro_main1.png" />
                </Grid.Column>
                <Grid.Column width={9}>
                  <Header as="h3" className={cx('area-2-text-1')}>
                    {defineMessages(
                      formatMessage({ id: 'Intro_3', defaultMessage: '"메일의 첨부파일은 결코 안전하지 않습니다"' })
                    )}
                  </Header>
                  <div className={cx('area-2-text-2')}>
                    {ReactHtmlParser(
                      defineMessages(
                        formatMessage({
                          id: 'Intro_4',
                          defaultMessage: (
                            <div>
                              보안인식 제고를 위한 <b>악성메일 대응 모의 훈련서비스, </b>
                              <b>MudFix</b>와 함께하세요
                            </div>
                          )
                        })
                      )
                    )}
                  </div>
                  <ul className={cx('area-2-text-3')}>
                    <li>
                      <div>
                        {defineMessages(
                          formatMessage({
                            id: 'Intro_5',
                            defaultMessage: '이메일을 통한 감염, 개인정보 유출, APT 공격 등'
                          })
                        )}
                      </div>
                      <div>
                        {defineMessages(
                          formatMessage({ id: 'Intro_6', defaultMessage: '침해사고 발생 가능성 실태 파악' })
                        )}
                      </div>
                    </li>
                    <li>
                      <div>
                        {defineMessages(
                          formatMessage({
                            id: 'Intro_7',
                            defaultMessage: '악성메일 공격 회피에 대한 지속적인 반복 훈련을 통해'
                          })
                        )}
                      </div>
                      <div>
                        {defineMessages(
                          formatMessage({
                            id: 'Intro_8',
                            defaultMessage: '개인의 분별력 제고 및 보안의식 수준 측정/관리'
                          })
                        )}
                      </div>
                    </li>
                  </ul>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
          {/* 영역 3 */}
          <Segment className={cx('area-3')} vertical>
            <Container text>
              <Header as="h5" className={cx('area-3-text-1')}>
                {defineMessages(formatMessage({ id: 'Intro_9', defaultMessage: '랜섬웨어 예방' }))}
              </Header>
              <div className={cx('area-3-text-2')}>
                <div>
                  {defineMessages(
                    formatMessage({
                      id: 'Intro_10',
                      defaultMessage: '당신의 소중한 데이터를 위협하는 랜섬웨어 멀웨어(워너크라이, 워너크립트 등)'
                    })
                  )}
                </div>
                <div>
                  {defineMessages(
                    formatMessage({
                      id: 'Intro_11',
                      defaultMessage: 'MudFix는 악성메일 모의 테스트를 통해 2차 피해를 미연에 방지합니다.'
                    })
                  )}
                </div>
              </div>
            </Container>
          </Segment>
          {/* 영역 4 */}
          <Segment className={cx('area-4')} vertical>
            <Container text>
              <div className={cx('area-4-content')}>
                <div className={cx('area-4-inner')}>
                  <div className={cx('area-4-img-cover')}>
                    <img className={cx('area-4-img')} src="/img/intro/intro_main2.png" />
                  </div>
                  <Header as="h5" className={cx('area-4-text-1')}>
                    {defineMessages(formatMessage({ id: 'Intro_12', defaultMessage: '보안인식 제고' }))}
                  </Header>
                  <div className={cx('area-4-text-2')}>
                    {defineMessages(
                      formatMessage({
                        id: 'Intro_13',
                        defaultMessage:
                          '반복적인 훈련을 통하여 보안 인식이 부족한 사람들의 보안 인식을 제고하게 합니다.'
                      })
                    )}
                  </div>
                </div>
                <div className={cx('area-4-inner')}>
                  <div className={cx('area-4-img-cover')}>
                    <img className={cx('area-4-img')} src="/img/intro/intro_main3.png" />
                  </div>
                  <Header as="h5" className={cx('area-4-text-1')}>
                    {defineMessages(formatMessage({ id: 'Intro_14', defaultMessage: '훈련대상 관리' }))}
                  </Header>
                  <div className={cx('area-4-text-2')}>
                    {defineMessages(
                      formatMessage({
                        id: 'Intro_15',
                        defaultMessage:
                          '훈련이 필요한 대상들을 연관 태그, 검색 기능을 이용하려 손쉽게 관리 및 선택 할 수 있습니다.'
                      })
                    )}
                  </div>
                </div>

                <div className={cx('area-4-inner')}>
                  <div className={cx('area-4-img-cover')}>
                    <img className={cx('area-4-img')} src="/img/intro/intro_main4.png" />
                  </div>
                  <Header as="h5" className={cx('area-4-text-1')}>
                    {defineMessages(formatMessage({ id: 'Intro_16', defaultMessage: '쉽고 빠른 통계 확인' }))}
                  </Header>
                  <div className={cx('area-4-text-2')}>
                    {defineMessages(
                      formatMessage({
                        id: 'Intro_17',
                        defaultMessage: '각 훈련별, 대상별로 쉽고 빠르게 시각적으로 통계 확인이 가능합니다.'
                      })
                    )}
                  </div>
                </div>
              </div>
            </Container>
          </Segment>
          {/* 영역 5 */}
          <Segment className={cx('area-5')} vertical>
            <Grid celled="internally" columns="equal" stackable>
              <Grid.Row textAlign="center">
                <Grid.Column className={cx('area-5-left')}>
                  <Header as="h3" className={cx('area-5-text-1')}>
                    {defineMessages(
                      formatMessage({ id: 'Intro_18', defaultMessage: '머드픽스를 통한 완벽 악성 메일 예방' })
                    )}
                  </Header>
                  <div className={cx('area-5-text-2')}>
                    {defineMessages(
                      formatMessage({
                        id: 'Intro_19',
                        defaultMessage: '악성 메일 공격을 통한 PC감염을 미연에 방지하세요.'
                      })
                    )}
                  </div>
                </Grid.Column>
                <Grid.Column className={cx('area-5-right')}>
                  <Header as="h3" className={cx('area-5-text-1')}>
                    {defineMessages(
                      formatMessage({ id: 'Intro_20', defaultMessage: '모의 테스트를 통한 완벽한 사내 보안 관리' })
                    )}
                  </Header>
                  <div className={cx('area-5-text-2')}>
                    {defineMessages(
                      formatMessage({
                        id: 'Intro_21',
                        defaultMessage: '모의 테스트를 통한 통계 수치로 완벽한 회사의 보안을 구성해보세요.'
                      })
                    )}
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
          {/* 영역 6 */}
          <Segment className={cx('area-6')} vertical>
            <Grid container stackable verticalAlign="middle">
              <Grid.Row>
                <Grid.Column width={11}>
                  <Header as="h3" className={cx('area-6-text-1')}>
                    {defineMessages(
                      formatMessage({
                        id: 'Intro_22',
                        defaultMessage: '악성메일 모의 테스트를 통해 단단한 기업 보안을 준비하세요.'
                      })
                    )}
                  </Header>
                  <div className={cx('area-6-text-2')}>
                    {defineMessages(formatMessage({ id: 'Intro_23', defaultMessage: '이미 회원이신가요?' }))}
                    <a href="/login" className={cx('ml-5')}>
                      {defineMessages(formatMessage({ id: 'Intro_24', defaultMessage: '로그인' }))}
                    </a>
                  </div>
                </Grid.Column>
                <Grid.Column width={5}>
                  {commonVar.isSaas === 1 && (
                    <Button
                      className={cx('area-6-bt-start')}
                      onClick={() => {
                        window.location.href = '/register';
                      }}>
                      {defineMessages(formatMessage({ id: 'Intro_25', defaultMessage: '서비스 가입 후 시작하기' }))}
                    </Button>
                  )}
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
          <Footer />
        </div>
      </div>
    );
  }
}

Intro.propTypes = {};
Intro.defaultProps = {};

export default injectIntl(Intro);



// WEBPACK FOOTER //
// ./src/script/components/intro/Intro.js